import React, { useState } from 'react'
import TextFieldUniversal from '../../../../../validate/form/text/TextFieldUniversal'

const SupplyOrderItemNameField = ({ required, setValidate, setValueForm, forciblyValue }) => {

	const [value, setValue] = useState('')

  return (
    <TextFieldUniversal
        value={value}
        setValue={e => {
            setValueForm(e)
            setValue(e)
        }}
        setValidate={setValidate}
        label={'Назва позиції'} 
        placeholder={'гайки 10х10...'}
        validates={{
            isEmpty: true,
        }}
        forciblyValue={forciblyValue}
        required={required}
        // multiline
        // rows={2}
		
    />
  )
}

export default SupplyOrderItemNameField